import { Auth, route } from './container';
import auth from './reducer';

const reducer = { auth };
export { Auth, route, reducer };